module.exports = __webpack_public_path__ + "ca1043fa6bda4fec467e680a47f96e08.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/screenshots/MatchMemobileimgur.png
 ** module id = 205
 ** module chunks = 0
 **/